import { Routes, Route } from 'react-router-dom';
import Header from './header';
import Footer from './footer';
import PartnerBridgeLogin from './pages/partner_bridge_login/partner_bridge_login';
import FccLogin from './pages/fcc_login/fcc_login';
import DWPLogin from './pages/dwp_login/dwp_login';
import DWPLoginNext from './pages/dwp_login_next/dwp_login_next';
import InpuKanjiName from "./pages/input_kanji_name/input_kanji_name";
import InquiryCreate from './pages/inquiry_create/inquiry_create';
import InquiryConfirm from './pages/inquiry_confirm/inquiry_confirm';
import InquiryStatus from './pages/inquiry_status/inquiry_status';
import ContactCreate from './pages/contact_create/contact_create';
import ContactConfirm from './pages/contact_confirm/contact_confirm';
import ContactComplete from './pages/contact_complete/contact_complete';
import UserInfoEdit from './pages/user_info_edit/user_info_edit';
import UserInfoConfirm from './pages/user_info_confirm/user_info_confirm';
import UserInfoCompelition from './pages/user_info_completion/user_info_completion';
import RelationInquiryCreate from './pages/relation_inquiry_create/relation_inquiry_create';
import RelationInquiryConfirm from './pages/relation_inquiry_confirm/relation_inquiry_confirm';
import InquiryCompletion from './pages/inquiry_completion/inquiry_completion';
import FileInfoEdit from './pages/file_info_edit/file_info_edit';
import FileInfoConfirm from './pages/file_info_confirm/file_info_confirm';
import FileUpload from './pages/file_upload/file_upload';
import FileUploadComplete from './pages/file_upload_complete/file_upload_complete';
import AboutContact from './pages/about_contact_center/about_contact_center';
import AboutContactService from './pages/about_contact_service/about_contact_service';
import PersonalInfo from './pages/personal_information/personal_information';
import HandlePersonalInfo from './pages/handle_personal_info/handle_personal_info';
import ScrollToTop from './ScrollToTop';
import AuthVerify from './auth-Verify';
import useBlockBackButtom from "./useBlockBackButtom"

function App() {
    useBlockBackButtom();

    return (
        <>
            <AuthVerify />
            <div lang='ja'>
                <ScrollToTop />
                <Header />
                <Routes >
                    <Route >
                        <Route exact path='/' element={<FccLogin />} />
                        <Route path='/pb_login' element={<PartnerBridgeLogin />} />
                        <Route path='/dwp_login' element={<DWPLogin />} />
                        <Route path='/dwp_login_next' element={<DWPLoginNext />} />
                        <Route path='/fcc_login' element={<FccLogin />} />
                        <Route path='/personal_information' element={<PersonalInfo AuthVerify={AuthVerify} />} />
                        <Route path='/input_kanji_name' element={<InpuKanjiName AuthVerify={AuthVerify} />} />
                        <Route path='/inquiry_create' element={<InquiryCreate />} />
                        <Route path='/inquiry_confirm' element={<InquiryConfirm AuthVerify={AuthVerify} />} />
                        <Route path='/inquiry_status' element={<InquiryStatus AuthVerify={AuthVerify} />} />
                        <Route path='/contact_create' element={<ContactCreate />} />
                        <Route path='/contact_confirm' element={<ContactConfirm />} />
                        <Route path='/contact_complete' element={<ContactComplete />} />
                        <Route path='/user_info_edit' element={<UserInfoEdit />} />
                        <Route path='/user_info_confirm' element={<UserInfoConfirm AuthVerify={AuthVerify} />} />
                        <Route path='/user_info_completion' element={<UserInfoCompelition />} />
                        <Route path='/relation_inquiry_create' element={<RelationInquiryCreate AuthVerify={AuthVerify} />} />
                        <Route path='/relation_inquiry_confirm' element={<RelationInquiryConfirm AuthVerify={AuthVerify} />} />
                        <Route path='/inquiry_completion' element={<InquiryCompletion AuthVerify={AuthVerify} />} />
                        <Route path='/file_info_edit' element={<FileInfoEdit />} />
                        <Route path='/file_info_confirm' element={<FileInfoConfirm />} />
                        <Route path='/file_upload' element={<FileUpload AuthVerify={AuthVerify} />} />
                        <Route path='/file_upload_complete' element={<FileUploadComplete AuthVerify={AuthVerify} />} />
                        <Route path='/about_contact_center' element={<AboutContact />} />
                        <Route path='/about_contact_service' element={<AboutContactService />} />
                        <Route path='/handle_personal_info' element={<HandlePersonalInfo />} />
                    </Route>
                </Routes>
                <Footer />
            </div>
        </>

    );
}

export default App;